import type { CartLine } from './types'

const storageKey = (organizationId: number, venueId?: number | null) =>
  venueId != null
    ? `provisium-market-cart:${organizationId}:${venueId}`
    : `provisium-market-cart:${organizationId}`

export const loadCartLines = (organizationId: number, venueId?: number | null): CartLine[] => {
  try {
    const raw = localStorage.getItem(storageKey(organizationId, venueId))
    if (!raw) {
      return []
    }
    const parsed = JSON.parse(raw) as unknown
    if (!Array.isArray(parsed)) {
      return []
    }
    return parsed as CartLine[]
  } catch {
    return []
  }
}

export const saveCartLines = (organizationId: number, lines: CartLine[], venueId?: number | null) => {
  localStorage.setItem(storageKey(organizationId, venueId), JSON.stringify(lines))
}

export const clearCartLines = (organizationId: number, venueId?: number | null) => {
  localStorage.removeItem(storageKey(organizationId, venueId))
}
